/* eslint-disable react/prefer-stateless-function */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable simple-import-sort/sort */
import { Button, Grid } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, Route } from 'react-router-dom'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import NoteAddIcon from '@material-ui/icons/NoteAdd'
import { bindActionCreators } from 'redux'

import styles from '../../../resources/theme/global'
import { renderRoute } from '../../../util/utils'
import { getLaundryListData } from '../RestorationReducer'
import { report } from '../RestorationActions'
import Details from '../../laundryDashboard/pages/Details'

import Filter from './Filter'
import List from './List'
import New from './New'

class Laundries extends Component {
  render() {
    const { classes, permissions, filters, report } = this.props
    return (
      <>
        <Grid
          container
          className={classes.pageHead}
          spacing={1}
          alignItems="center"
        >
          <Grid item xs>
            <Typography variant="h4" color="secondary">
              Tapetes para restauração
            </Typography>
          </Grid>
          <Grid item>
            <Filter classes={classes} />
          </Grid>
          <Grid item>
            <Button
              color="primary"
              type="button"
              onClick={() => report(filters)}
            >
              <NoteAddIcon className={classes.btnIcon} /> Relatório
            </Button>
          </Grid>
          <Grid item>
            <Button
              color="primary"
              variant="contained"
              component={Link}
              to="/restoration-items/new"
            >
              <AddCircleOutlineIcon className={classes.btnIcon} /> Cadastrar
            </Button>
          </Grid>
        </Grid>

        <Route path="/restoration-items/:id/edit" component={Details} />
        <Route path="/restoration-items/new" component={New} />

        <List {...this.props} classes={classes} />
      </>
    )
  }
}

const mapStateToProps = state => ({
  ...getLaundryListData(state),
  permissions: state.auth.permissions || [],
  filters: state.restoration.filters,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      report,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Laundries))
